module.exports = __webpack_public_path__ + "img/record.b8806ede.svg";